module.exports = __webpack_public_path__ + "assets/img/news-4.96c73778.jpg";